module.exports = __webpack_public_path__ + "static/fipcrosebunny3-13bd5f129a12a252920cb36860432a8f.jpeg";